import styled from 'styled-components';

export const FlagWrapper = styled.div`
  display: flex;
`;
